import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ModalCompany from "./ModalCompany";
import { omit } from "lodash";

import toast from "react-hot-toast";

const animatedComponents = makeAnimated();

const initial_value = {
  company_id: "",
  client_name: "",
  services: [],
  other_charges: [],
};

export default function OutletAddOrder(props: any) {
  const [id_value, SerIdValue] = useState(useParams());
  const [company_data, SetCompanyData] = useState({});
  const [service_data, SetServiceData] = useState({});
  const [service_options, SetServiceOptions] = useState([]);
  const [event_data, SetEventData] = useState([]);
  const [save_data, SetSaveData] = useState(initial_value);
  const [queue_data, SetQueueData] = useState({
    service_id: "",
    service_value: {},
    event_id: "",
    event_value: {},
    quantity: "",
    notes: "",
    total_files: "",
    file_path: "",
    gst: false,
    amount: "",
    gst_amount: "",
    total_amount: "",
  });
  const [other_charge_data, SetOtherChargeData] = useState({
    title: "",
    amount: "",
    gst: false,
    gst_percent: "",
    hsn: "",
    gst_amount: "",
    total_amount: "",
  });
  const [errors, setErrors] = useState({});
  const [gst_percent, SetGstPercent] = useState("");
  const [order_data, SetOrderData] = useState({
    amount: "",
    gst_amount: "",
    total_amount: "",
  });

  useEffect(() => {
    console.log("AddOrder On mount :", props);
    get_order_init();
  }, []);

  useEffect(() => {
    console.log("On save data change caluculate_order_value");
    caluculate_order_value();
  }, [save_data]);

  async function get_order_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
      },
    };
    let data_res = await api("/outlet/create_order_init_v2", pass_data);
    console.log("get_order_init response :", data_res.response);
    if (data_res.response.hasOwnProperty("company")) {
      SetCompanyData(data_res.response.company[0]);
    }
    if (data_res.response.hasOwnProperty("services")) {
      SetServiceData(data_res.response.services);
      let service_value = [];
      Object.keys(data_res.response.services).forEach((service, index) => {
        let push_data = {
          label: "",
          options: [],
        };
        if (service == "type_1") {
          push_data.label = "Images";
        } else if (service == "type_2") {
          push_data.label = "Videos";
        } else if (service == "type_3") {
          push_data.label = "Audios";
        }
        push_data.options = data_res.response.services[service];
        service_value.push(push_data);
      });
      SetServiceOptions(service_value);
    }
    if (data_res.response.hasOwnProperty("events")) {
      SetEventData(data_res.response.events);
    }
    if (data_res.response.hasOwnProperty("settings")) {
      SetGstPercent(data_res.response.settings.gst_percent);
    }

    SetSaveData((prevValue) => {
      prevValue.services = [];
      prevValue.other_charges = [];
      prevValue.company_id = id_value.company_id;
      return { ...prevValue };
    });
  }

  const Switch = ({ isOn, handleToggle, onColor }) => {
    return (
      <>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={`react-switch-new`}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label"
          htmlFor={`react-switch-new`}
        >
          <span className={`react-switch-button`} />
        </label>
      </>
    );
  };

  async function create_order() {
    if (save_data.client_name != "") {
      if (save_data.services.length > 0) {
        let pass_data = {
          get: {
            brand: id_value.brand_id,
            outlet: id_value.outlet_id,
          },
          post: save_data,
        };
        console.log("create_order pass_data :", pass_data);
        let data_res = await api("/outlet/create_order_v2", pass_data);
        console.log("create_order_v2 response :", data_res.response);
        if (data_res.response.hasOwnProperty("id")) {
          SetSaveData(initial_value);
          window.history.back();
        }
      } else {
        console.log("Atleast add one service to create order");
        toast.error("Atleast add one service to create order");
      }
    } else {
      console.log("Enter Client Name");
      toast.error("Please enter Client Name");
    }
  }

  function caluculate_order_value() {
    let amount_value = 0,
      gst_amount_value = 0,
      total_amount_value = 0;
    save_data.services.map((s_ele: any, s_index: any) => {
      console.log("s_ele on caluculate_order_value :", s_ele);
      amount_value = parseFloat(amount_value, 2) + parseFloat(s_ele.amount, 2);
      if (s_ele.gst) {
        gst_amount_value =
          parseFloat(gst_amount_value, 2) + parseFloat(s_ele.gst_amount, 2);
      }

      total_amount_value =
        parseFloat(total_amount_value, 2) + parseFloat(s_ele.total_amount, 2);
    });
    save_data.other_charges.map((c_ele: any, c_index: any) => {
      amount_value = parseFloat(amount_value, 2) + parseFloat(c_ele.amount, 2);
      if (c_ele.gst) {
        gst_amount_value =
          parseFloat(gst_amount_value, 2) + parseFloat(c_ele.gst_amount, 2);
      }
      total_amount_value =
        parseFloat(total_amount_value, 2) + parseFloat(c_ele.total_amount, 2);
    });
    SetOrderData({
      amount: amount_value,
      gst_amount: gst_amount_value,
      total_amount: total_amount_value,
    });
  }

  function add_other_charge() {
    SetOtherChargeData((prevValue) => {
      let gst_amount_value, total_amount_value;
      gst_amount_value = (prevValue.gst_percent / 100) * prevValue.amount;
      if (prevValue.gst) {
        total_amount_value =
          parseFloat(gst_amount_value, 2) + parseFloat(prevValue.amount, 2);
      } else {
        total_amount_value = prevValue.amount;
      }
      prevValue.total_amount = total_amount_value;
      prevValue.gst_amount = gst_amount_value;
      SetSaveData((sprevValue) => {
        sprevValue.other_charges.push(prevValue);
        return { ...sprevValue };
      });
      return { ...prevValue };
    });

    SetOtherChargeData({
      title: "",
      amount: "",
      gst: false,
      gst_percent: "",
      hsn: "",
      gst_amount: "",
      total_amount: "",
    });
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4 d-flex cursor">
        <div
          onClick={() => {
            SetSaveData(initial_value);

            window.history.back();
          }}
        >
          <img
            src={require("../../../assets/icon/svg/arrow-left.svg")}
            className="action-img"
          />
        </div>
        <h5 className="  mb-0 ps-2 text-dark fw-bolder">Create Order</h5>
      </div>

      <div className="container-fuild p-3">
        <div className="row">
          <div className="col-md-8">
            <div className="card p-3 br-3">
              <div className="row">
                {Object.keys(company_data).length != 0 ? (
                  <div className=" mb-3">
                    <h6 className="mb-3">Customer Details</h6>
                    <p className="mb-2 text-secondary">
                      Name :
                      <b className="text-dark">&nbsp;{company_data.name}</b>
                    </p>
                    <p className="mb-2 text-secondary">
                      Email :
                      <b className="text-dark">&nbsp;{company_data.email}</b>
                    </p>
                    <p className="mb-2 text-secondary">
                      GST no :
                      <b className="text-dark">&nbsp;{company_data.gstin}</b>
                    </p>
                    <p className="mb-2 text-secondary">
                      Mobile :
                      <b className="text-dark">&nbsp;{company_data.mobile}</b>
                    </p>

                    <div className="mt-4">
                      <label className="form-label text-dark fs-6 fw-600">
                        Client Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={save_data.client_name}
                        required
                        onChange={(e) => {
                          console.log("Client name", e.target.value);
                          SetSaveData((preValue) => {
                            preValue.client_name = e.target.value;
                            return { ...preValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="card p-3 mt-4">
              <h6 className="">Add Service</h6>
              <div className="row my-2 align-items-center">
                {/* Service */}
                <div className="col-md-4 col-6 mb-2">
                  <label className="form-label">Service</label>
                  <Select
                    components={animatedComponents}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={queue_data.service_value}
                    options={service_options}
                    onChange={(e) => {
                      console.log("service on change :", e);
                      SetQueueData((prevValue) => {
                        prevValue.service_id = e.id;
                        prevValue.service_value = e;
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* Event */}
                <div className="col-md-3 col-6 mb-2">
                  <label className="form-label">Event</label>
                  <Select
                    components={animatedComponents}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={queue_data.event_value}
                    options={event_data}
                    onChange={(e) => {
                      console.log("event on change :", e);
                      SetQueueData((prevValue) => {
                        prevValue.event_id = e.id;
                        prevValue.event_value = e;
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* Quantity */}
                <div className="col-md-3 col-8  mb-2">
                  <label className="form-label">Quantity / Duration</label>
                  <input
                    type="number"
                    className="form-control"
                    required
                    value={queue_data.quantity}
                    onChange={(e) => {
                      SetQueueData((prevValue) => {
                        prevValue.quantity = e.target.value;
                        return { ...prevValue };
                      });
                    }}
                  />
                  {errors.quantity && (
                    <small className="text-red">{errors.quantity}</small>
                  )}
                </div>
                {/* Gst / Add */}
                <div className="col-md-2 col-4">
                  <label className="form-label d-flex mb-0 pt-2">
                    <input
                      type="checkbox"
                      className="form-check me-2"
                      required
                      checked={queue_data.gst}
                      onChange={(e) => {
                        console.log("Switch on change :", e);
                        SetQueueData((prevValue) => {
                          prevValue.gst = !prevValue.gst;
                          return { ...prevValue };
                        });
                      }}
                    />
                    <div>
                      <p className="mb-0">GST</p>
                    </div>
                  </label>
                  {/* <Switch
                    isOn={queue_data.gst}
                    onColor="#06D6A0"
                    handleToggle={(e) => {
                      console.log("Switch on change :", e);
                      SetQueueData((prevValue) => {
                        prevValue.gst = !prevValue.gst;
                        return { ...prevValue };
                      });
                    }}
                  /> */}
                </div>
                <div className="col-12 d-flex justify-content-end">
                  <button
                    className="btn btn-light-outline text-dark cursor btn-sm d-flex"
                    onClick={() => {
                      console.log("Add Service :", queue_data);
                      if (
                        queue_data.service_id != "" &&
                        queue_data.quantity != ""
                      ) {
                        console.log("ok");
                        let price = queue_data.service_value.price;
                        let price_quantity =
                          queue_data.service_value.price_quantity;

                        let service_price = parseFloat(price / price_quantity);
                        let amount_value = parseFloat(
                          service_price * queue_data.quantity
                        );
                        let gst_amount_value, total_amount_value;
                        gst_amount_value = (gst_percent / 100) * amount_value;

                        if (queue_data.gst) {
                          total_amount_value = gst_amount_value + amount_value;
                        } else {
                          total_amount_value = amount_value;
                        }
                        SetQueueData((prevValue) => {
                          prevValue.total_amount =
                            parseFloat(total_amount_value).toFixed(2);
                          prevValue.gst_amount =
                            parseFloat(gst_amount_value).toFixed(2);
                          prevValue.amount =
                            parseFloat(amount_value).toFixed(2);
                          SetSaveData((SetprevValue) => {
                            SetprevValue.services.push(prevValue);
                            return { ...SetprevValue };
                          });
                          return { ...prevValue };
                        });

                        SetQueueData({
                          service_id: "",
                          service_value: {},
                          event_id: "",
                          event_value: {},
                          quantity: "",
                          notes: "",
                          total_files: "",
                          file_path: "",
                          gst: false,
                          amount: "",
                          gst_amount: "",
                          total_amount: "",
                        });
                      } else {
                        console.log("Need Service and quantity and event");
                      }
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/plus1.svg")}
                      className="action_menu_img"
                    />
                    <p className="text-dark mb-0 ps-2">Add</p>
                  </button>
                </div>
              </div>
            </div>

            <div className="card mt-4 mb-4">
              <h6 className="p-3 pb-0">Services</h6>
              {save_data.services != "" ? (
                <div className="scrollY">
                  <div className="row p-3">
                    {save_data.services.map(
                      (service_item, service_item_index) => (
                        <div
                          className="col-md-6 mb-3 border-bottom p-3 px-4"
                          key={service_item_index}
                        >
                          <div className="row pt-2">
                            <div className="col-11 mb-3">
                              <p className="mb-0 text-dark fw-bold fs-7">
                                {service_item.service_value.name}
                              </p>
                              <p className="mb-0 mt-1 v-small">
                                {service_item.event_value.name}
                              </p>
                            </div>
                            <div
                              className="col-1 mb-3 p-0 cursor text-end"
                              onClick={() => {
                                console.log("remove");
                                SetSaveData((prevValue) => {
                                  prevValue.services.splice(
                                    service_item_index,
                                    1
                                  );
                                  return { ...prevValue };
                                });
                              }}
                            >
                              <img
                                src={require("../../../assets/icon/svg/x1.svg")}
                                className="action_menu_img"
                              />
                            </div>

                            <div className="col-6 mb-2 d-flex align-items-center">
                              <p className="mb-0 text-dark">Qty :</p>
                              <p className="ps-2 m-0 text-gray">
                                {service_item.quantity}
                              </p>
                            </div>
                            <div className="col-6 mb-2 pe-1 d-flex align-items-center justify-content-end">
                              <p className="mb-0 text-dark">GST :</p>
                              <p className="ps-2 m-0 text-gray">
                                {service_item.gst ? "Yes" : "No"}
                              </p>
                            </div>

                            {/* Notes */}
                            <div className="mb-2 mt-1 pe-1">
                              <label className="form-label">Notes</label>
                              <textarea
                                placeholder="Enter some notes"
                                className="form-control"
                                rows={3}
                                value={service_item.notes}
                                onChange={(e) => {
                                  SetSaveData((prevValue) => {
                                    prevValue.services[
                                      service_item_index
                                    ].notes = e.target.value;
                                    return { ...prevValue };
                                  });
                                }}
                              ></textarea>
                            </div>

                            {/* file path */}
                            <div className="col-6 mb-2 pe-1">
                              <label className="form-label">
                                RAW File path
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={service_item.file_path}
                                onChange={(e) => {
                                  SetSaveData((prevValue) => {
                                    prevValue.services[
                                      service_item_index
                                    ].file_path = e.target.value;
                                    return { ...prevValue };
                                  });
                                }}
                              />
                            </div>
                            {/* Total Files */}
                            <div className="col-6 mb-2 pe-1">
                              <label className="form-label">
                                Total RAW Files
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={service_item.total_files}
                                onChange={(e) => {
                                  SetSaveData((prevValue) => {
                                    prevValue.services[
                                      service_item_index
                                    ].total_files = e.target.value;
                                    return { ...prevValue };
                                  });
                                }}
                              />
                            </div>
                            {/* Amount */}
                            <div className="col-6 mb-2 pe-1">
                              <label className="form-label">Amount</label>
                              <input
                                type="text"
                                className="form-control"
                                value={service_item.amount}
                                onChange={(e) => {
                                  SetSaveData((prevValue) => {
                                    let gst_amount_value,
                                      total_amount_value,
                                      entered_amount;
                                    entered_amount = e.target.value;
                                    gst_amount_value =
                                      (gst_percent / 100) * entered_amount;
                                    if (
                                      prevValue.services[service_item_index].gst
                                    ) {
                                      total_amount_value =
                                        parseFloat(gst_amount_value, 2) +
                                        parseFloat(entered_amount, 2);
                                    } else {
                                      total_amount_value =
                                        parseFloat(entered_amount).toFixed(2);
                                    }

                                    prevValue.services[
                                      service_item_index
                                    ].amount = entered_amount;
                                    prevValue.services[
                                      service_item_index
                                    ].gst_amount = gst_amount_value;
                                    prevValue.services[
                                      service_item_index
                                    ].total_amount = total_amount_value;

                                    return { ...prevValue };
                                  });
                                }}
                              />
                            </div>
                            {/* Gst Amount */}
                            {service_item.gst ? (
                              <div className="col-6 mb-2 pe-1">
                                <label className="form-label">GST Amount</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={true}
                                  value={service_item.gst_amount}
                                />
                              </div>
                            ) : null}

                            {/* Total Amount */}
                            <div className="col-6 mb-2 pe-1">
                              <label className="form-label">Total Amount</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled={true}
                                value={service_item.total_amount}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ) : (
                <div className="text-center align-items-center pb-3">
                  <img
                    src={require("../../../assets/img/svg/no_data_2.svg")}
                    className="w-30 pb-2"
                  />
                  <p className="v-small mb-0">
                    No Service, Please Add Some Service
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-4 ">
            <div className="card p-3">
              <div className="mt-2 row align-items-center">
                <div className="col-9 pe-0 mb-3">
                  <h6>Add Charges</h6>
                </div>
                <div
                  className="col-3 mb-3"
                  onClick={() => {
                    console.log("Add other charge data :", other_charge_data);
                    if (
                      other_charge_data.title != "" &&
                      other_charge_data.amount != ""
                    ) {
                      if (other_charge_data.gst) {
                        if (other_charge_data.gst_percent != "") {
                          add_other_charge();
                          console.log("other charge ok to add with gst");
                        } else {
                          console.log("other charge enter gdt %");
                        }
                      } else {
                        add_other_charge();
                        console.log("other charge ok to add with out gst");
                      }
                    } else {
                      console.log("other charge add title, amount and others");
                    }
                  }}
                >
                  <div className="btn-light-outline d-flex align-items-center  justify-content-center text-dark cursor py-1 px-2">
                    <img
                      src={require("../../../assets/icon/svg/plus1.svg")}
                      className="action_menu_img"
                    />
                    <p className="text-dark mb-0">Add</p>
                  </div>
                </div>
                {/* Title */}
                <div className="col-6 mb-2">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={other_charge_data.title}
                    onChange={(e) => {
                      SetOtherChargeData((prevValue) => {
                        prevValue.title = e.target.value;
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* Amount */}
                <div className="col-6 mb-2">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    required
                    value={other_charge_data.amount}
                    onChange={(e) => {
                      SetOtherChargeData((prevValue) => {
                        prevValue.amount = e.target.value;
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
                {/* GST */}
                <div className="col-6 mb-2">
                  <label className="form-label d-flex mt-1">
                    <input
                      type="checkbox"
                      className="form-check me-2"
                      required
                      checked={other_charge_data.gst}
                      onChange={(e) => {
                        SetOtherChargeData((prevValue) => {
                          prevValue.gst = !prevValue.gst;
                          return { ...prevValue };
                        });
                      }}
                    />
                    GST
                  </label>
                  {/* Gst % */}
                  {other_charge_data.gst ? (
                    <div className="input-group">
                      <input
                        type="number"
                        className="form-control"
                        required
                        value={other_charge_data.gst_percent}
                        onChange={(e) => {
                          SetOtherChargeData((prevValue) => {
                            prevValue.gst_percent = e.target.value;
                            return { ...prevValue };
                          });
                        }}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">%</span>
                      </div>
                    </div>
                  ) : null}
                </div>

                {/* Hsn */}
                <div className="col-6 mb-2">
                  <label className="form-label">HSN</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={other_charge_data.hsn}
                    onChange={(e) => {
                      SetOtherChargeData((prevValue) => {
                        prevValue.hsn = e.target.value;
                        return { ...prevValue };
                      });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card mt-4">
              <h6 className="p-3">Other Charges</h6>
              {save_data.other_charges != "" ? (
                <div className="scrollY_h">
                  {save_data.other_charges.map(
                    (charge_item, charge_item_index) => (
                      <div className="p-3" key={charge_item_index}>
                        <div className="row px-2 border-bottom">
                          <div className="col-11 mb-2 ">
                            <p className="m-0 text-dark fw-bold">
                              Title : {charge_item.title}
                            </p>
                            <p className="m-0 text-dark fw-bold">
                              GST : {charge_item.gst ? "true" : "false"}
                            </p>
                            {charge_item.gst ? (
                              <p className="m-0 text-dark fw-bold">
                                GST % : {charge_item.gst_percent}
                              </p>
                            ) : null}

                            <p className="m-0 text-dark fw-bold">
                              HSN : {charge_item.hsn}
                            </p>
                            <p className="pt-1 m-0 text-gray">
                              Amount : &#8377; {charge_item.amount}
                            </p>
                            {charge_item.gst ? (
                              <p className="pt-1 m-0 text-gray">
                                GST Amount : &#8377; {charge_item.gst_amount}
                              </p>
                            ) : null}

                            <p className="pt-1 m-0 text-gray">
                              Total Amount : &#8377; {charge_item.total_amount}
                            </p>
                          </div>
                          <div
                            className="col-1 ps-0 text-end mb-2"
                            onClick={() => {
                              console.log("remove");
                              SetSaveData((prevValue) => {
                                prevValue.other_charges.splice(
                                  charge_item_index,
                                  1
                                );
                                return { ...prevValue };
                              });
                            }}
                          >
                            <img
                              src={require("../../../assets/icon/svg/x1.svg")}
                              className="action_menu_img"
                            />
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <div className="text-center align-items-center pb-3">
                  <img
                    src={require("../../../assets/img/svg/no_data_2.svg")}
                    className="w-30 pb-2"
                  />
                  <p className="v-small mb-0">No Charges, Add Some Charges</p>
                </div>
              )}
            </div>
            <div className="card p-3 mt-4">
              <div className="d-flex mt-3 border-bottom">
                <p>Amount</p>
                <div className="ms-auto">{order_data.amount}</div>
              </div>
              <div className="d-flex mt-2">
                <p>GST Amount</p>
                <div className="ms-auto">{order_data.gst_amount}</div>
              </div>
              <div className="d-flex mt-2">
                <p>Total Amount</p>
                <div className="ms-auto">{order_data.total_amount}</div>
              </div>
              <div className="mt-4 text-end">
                <button
                  className="btn btn-light-outline col-12"
                  onClick={() => {
                    console.log("create order :", save_data);
                    create_order();
                  }}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
